import React, { memo } from "react";
import { Box, Container, Typography } from "@mui/material";
import { RightPaddingWrapper } from "../../../../Components/RightPaddingWrapper/RightPaddingWrapper";

import doorbellIcon from "../../../../Assets/images/partners/doorbell.webp";
import neighborhoodIcon from "../../../../Assets/images/partners/neighborhood.webp";
import searchIcon from "../../../../Assets/images/partners/search.webp";
import weatherIcon from "../../../../Assets/images/partners/weather.webp";
import smartHomeIcon from "../../../../Assets/images/partners/smart-home.webp";

// Per-icon display height (the desktop/md size). The generated icons have
// different internal padding (e.g. neighborhood is wide/short with lots of
// whitespace, doorbell fills its canvas), so a single height makes the subjects
// look unequal. These even out the *visual* subject size across the row and are
// scaled down responsively for smaller screens.
const partnerIcons = [
  { src: doorbellIcon, name: "Doorbell", height: 160 },
  { src: smartHomeIcon, name: "Smart Home", height: 190 },
  { src: weatherIcon, name: "Weather", height: 190 },
  { src: searchIcon, name: "Search", height: 190 },
  { src: neighborhoodIcon, name: "Neighborhood", height: 230 },
];

const Partners = memo(() => {
  return (
    <Container maxWidth={"xl"} disableGutters>
      <RightPaddingWrapper>
        <Box>
          <Typography variant="h4" fontWeight={500}>
            Integrations to power the
            <Typography ml={2} variant="h4" fontWeight="700" component={"span"}>
              future of your property
            </Typography>
          </Typography>
        </Box>
        <Box
          mt={"30px"}
          sx={{
            mb: {
              sm: 10,
              lg: 20,
            },
          }}
        >
          <Box
            sx={{
              gap: { xs: "1rem", md: "1.5rem", lg: "2rem", xl: "2.5rem" },
              display: "flex",
              alignItems: "center",
              overflowX: "auto",
              overflowY: "hidden",
              "&::-webkit-scrollbar": {
                display: "none",
              },
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            {partnerIcons.map((icon, i) => (
              <Box key={i} sx={{ flexShrink: 0 }}>
                <Box
                  component="img"
                  src={icon.src}
                  alt={icon.name}
                  sx={{
                    // Source icons are large square (~1024px) webp canvases with
                    // uneven padding — per-icon base height balances them, scaled
                    // down on smaller screens.
                    height: {
                      xs: icon.height * 0.62,
                      sm: icon.height * 0.8,
                      md: icon.height,
                    },
                    width: "auto",
                    objectFit: "contain",
                    display: "block",
                  }}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </RightPaddingWrapper>
    </Container>
  );
});

export default Partners;
